module.exports = __webpack_public_path__ + "img/manta.d0e0860a.png";